import * as THREE from 'three';

import { Model } from '../lib/Model';

export class SceneDirectionalLight extends Model {
    constructor(viewer) {
        super('DirectionalLight', viewer);
        this.model = new THREE.DirectionalLight(0xffffff, 1);
    }

    init() {
        this.model.castShadow = true;
        this.model.shadow.mapSize.width = 1024 * 4;
        this.model.shadow.mapSize.height = 1024 * 4;
        this.model.position.set(1, 3, 2);

        this.model.shadow.camera.far = 6;
        this.model.shadow.camera.near = 1;
        this.model.shadow.bias = -0.003;

        if (this.viewer.debug) {
            const cameraHelper = new THREE.CameraHelper(this.model.shadow.camera);
            this.viewer.scene.add(cameraHelper);
        }

        super.init();
    }

    // eslint-disable-next-line class-methods-use-this
    animate() {}

    dispose() {
        this.model.shadow.dispose();
        super.dispose();
    }
}
